import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-popup-wizard-footer',
    templateUrl: './popup-wizard-footer.component.html',
    styleUrls: ['./popup-wizard-footer.component.scss'],
    standalone: false
})
export class PopupWizardFooterComponent {

    @Output()
    public navigateForwardClicked: EventEmitter<void> = new EventEmitter<void>();

    @Output()
    public navigateBackClicked: EventEmitter<void> = new EventEmitter<void>();

    @Input({required: true})
    public isBackVisible!: boolean;

    @Input({required: true})
    public isForwardVisible!: boolean;

    @Input({required: true})
    public isForwardDisabled!: boolean;

    @Input({required: true})
    public hasCustomContent!: boolean;

    @Input()
    public forwardText: string | undefined;

    @Input()
    public backText: string | undefined;

}
